// https://github.com/junipersquare/main/blob/3f1ae48ce2a653a36709e9cc8e12de6f16f7990d/jsq/client/src/common/utils/isUSA/isUSA.ts#L6-L11
/**
 * Checks if a given country is the United States of America (USA).
 * @param country - The country to be checked.
 * @returns Returns true if the country is the United States of America (USA), false otherwise.
 */
export const isUSA = (country: string | null | undefined) => {
  if (!country) {
    return false;
  }
  return /^\s*(?:USA?|U\.S\.(?:A\.?)?|United States(?: of America)?)\s*$/i.test(country);
};
